import { mercuryApi } from '$api'
import { StaffRole, transformStaffRoleOnGet } from '$models'
import { createQueryString } from '$utils'
import sortBy from 'lodash/sortBy'

/**
 * Get all Staff Role
 * @param includeDeleted - include the deleted staff roles
 * @returns Promise<StaffRole[]>
 */
export const getAll = async (
  includeDeleted: boolean = true
): Promise<StaffRole[]> => {
  const queryString = createQueryString({
    includeDeleted: includeDeleted,
  })

  const result = await mercuryApi.get<StaffRole[]>(
    `/staff-roles?${queryString}`
  )
  const transformedStaffRoles = result.map(transformStaffRoleOnGet)
  return sortBy<StaffRole>(transformedStaffRoles, 'name')
}
